

const url=process.env.VUE_APP_API_URL+process.env.VUE_APP_STAGE;

export default url;